module.exports = __webpack_public_path__ + "img/logo.ed561732.png";